import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 验收项目列表
export const setAcceptancePages: Mutation<IModuleState> = (state, payload) => {
  state.acceptancePage.data = payload.data;
  state.acceptancePage.total = payload.total;
  state.acceptancePage.pageNum = payload.pageNum;
  state.acceptancePage.pageSize = payload.pageSize;
  state.acceptancePage.loading = !!payload.loading;
};

// 验收项目详情
export const setAcceptanceDetail: Mutation<IModuleState> = (state, payload) => {
  state.acceptanceDetail.data = payload.data;
  state.acceptanceDetail.loading = !!payload.loading;
};

// 验收项目操作日志
export const setAcceptanceLogs: Mutation<IModuleState> = (state, payload) => {
  state.acceptanceLogs.data = payload.data;
  state.acceptanceLogs.loading = !!payload.loading;
};

// 验收项目反馈列表
export const setFeedbackList: Mutation<IModuleState> = (state, payload) => {
  state.feedbackList.data = payload.data;
  state.feedbackList.loading = !!payload.loading;
};

// 状态字典
export const setAcceptanceStatus: Mutation<IModuleState> = (state, payload) => {
  state.acceptanceStatus.raw = payload.raw;
  state.acceptanceStatus.data = payload.data;
  state.acceptanceStatus.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.type = payload.type;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

// 普通弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type;
  state.dialog.data = payload.data;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 列表搜索条件
export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
